import { InjectionToken } from '@angular/core';
import { ActionHeaderConfig } from '../../pattern/action-header/actionHeaderConfig.interface';

export const APP_LAYOUT = new InjectionToken<AumicoLayoutConfigs>('aumicoLayoutConfigs');

export type AumicoLayoutConfigs = AumicoLayoutConfig[];

export interface AumicoLayoutConfig {
    /**
     * A text for displaying the route
     */
    label?: string;

    /**
     * type of route
     * primary -> will be displayed in the primary navigation
     * secondary -> will be displayed in the secondary navigation
     * main -> overviewpage of subpages
     * sub -> will be displayed in the sub navigation
     * redirect -> will not be displayed
     */
    type?: string;

    /**
     * the name of the route for identification
     */
    name?: string;

    /**
     * the icon to be used when displaying in primary or secondary navigation.
     * the icon must be added as customized navigation icon
     */
    icon?: string;

    /**
     * describes all roles which are allowed to see this link
     * If public, roles: ['undefined']
     * If only SUPER_USER, roles: ['SUPER_USER'],
     * If SUPER_USER and ADMIN, roles: ['SUPER_USER', 'ADMIN']
     */
    canSeeNavigationLinkRoles?: [string];

    /**
     * Children (just changing the type to be AumicoRoute[] instead of Route[]
     */
    children?: AumicoLayoutConfigs;

    /**
     * parent route
     */
    parent?: AumicoLayoutConfig;

    /**
     * For Action header
     */
    actionHeaderConfig?: ActionHeaderConfig | null;

    isProceedButtonClicked?: boolean;
}
